import { supabase } from "./supabase";

export const DELETE_ACCOUNT_CONFIRM_PHRASE = "DELETE";
export const ACCOUNT_DELETED_FLAG = "judi-account-deleted";
export const ACCOUNT_DELETION_FAILED_MESSAGE =
  "Could not delete your account. Please try again.";

const E2E_USER_KEY = "__judi_e2e_user__";

let shownThisLoad = false;

interface DeleteAccountResponse {
  success?: boolean;
  error?: string;
}

export async function requestAccountDeletion(): Promise<void> {
  const { data, error } = await supabase.functions.invoke<DeleteAccountResponse>(
    "delete-account",
    { body: {} },
  );

  if (error || data?.error || !data?.success) {
    throw new Error(ACCOUNT_DELETION_FAILED_MESSAGE);
  }
}

export function markAccountDeleted(): void {
  shownThisLoad = true;
  sessionStorage.setItem(ACCOUNT_DELETED_FLAG, "1");
  try {
    localStorage.removeItem(E2E_USER_KEY);
  } catch {
    // E2E mock user key is only present in Playwright.
  }
}

export function consumeAccountDeletedFlag(): boolean {
  if (shownThisLoad) return true;
  try {
    if (sessionStorage.getItem(ACCOUNT_DELETED_FLAG) !== "1") return false;
    sessionStorage.removeItem(ACCOUNT_DELETED_FLAG);
    shownThisLoad = true;
    return true;
  } catch {
    return false;
  }
}

export function resetAccountDeletedNoticeForTests(): void {
  shownThisLoad = false;
  try {
    sessionStorage.removeItem(ACCOUNT_DELETED_FLAG);
  } catch {
    // ignore
  }
}
